import { Component } from '@angular/core';
import { IFloatingFilterParams } from 'ag-grid';
import { IFloatingFilterComp } from 'ag-grid-angular';
import { PershingTextFilter } from './pershing-text-filter.component';

@Component({
    templateUrl: './pershing-text-floating-filter.component.html'
})
export class PershingTextFloatingFilterComponent implements IFloatingFilterComp {
    value: string;
    operator: string = 'contains';
    isFiltered: boolean = false;
    isTypeAheadFilter: boolean = false;

    options: any[] = [
        { value: 'contains', text: 'Contains' },
        { value: 'notContains', text: 'Not Contains' }
    ];

    private params: PershingTextFloatingFilterParams;

    agInit(params: PershingTextFloatingFilterParams) {
        this.params = params;
        this.isTypeAheadFilter = (params.isTypeAheadFilter) ? params.isTypeAheadFilter : false;
    }
    // This method is called whenever the filter model (in this case, PershingNumberFilter) changes.
    // This occurs after the parent filter (in this case NxpNumberFilterComponent) invokes its getModel()
    // Can use this to reflect additional changes once parent filter model has been set... but not necessary
    onParentModelChanged(parentModel: PershingTextFilter): void {}

    setFilterState(value: string): void {
        this.operator = value;
    }

    isHighlighted(value: string): boolean {
        return this.operator === value;
    }

    clearFilter() {
        // An actual text entered for the filter then only clear & call svc
        if (this.value !== null && this.value !== undefined && this.value !== '') {
            this.value = '';
            this.applyFilter();
        }
    }

    applyFilter() {
        // When you first load the grid --> hit enter on filter with no value --> value is undefined. Don't do anything
        // When you clear filter --> hit enter --> value is an empty string
        if (this.value === undefined || this.value === '') {
            this.params.onFloatingFilterChanged({ model: null });
            this.isFiltered = false;
            this.operator = 'contains';
        }
        // An actual number entered for the filter
        if (!this.value !== null && this.value !== undefined && this.value !== '') {
            this.params.onFloatingFilterChanged({ model: this.buildModel()});
            this.isFiltered = true;
        }
    }

    buildModel(): PershingTextFilter {
        let model = {
            filter: this.value,
            filterTo: null,
            filterType: 'number', // This shouldn't be number
            type: this.operator,
            queryName: this.params.queryName
        };
        return model;
    }
}

export interface PershingTextFloatingFilterChange {
    model: PershingTextFilter;
}

export interface PershingTextFloatingFilterParams extends IFloatingFilterParams<PershingTextFilter, PershingTextFloatingFilterChange> {
    // The queryName is an optional field that can be provided to override the query filter paramater
    // name that's typically set by the column's colId. If "colId" is not present, it uses the column's "field".
    queryName?: string;
    isTypeAheadFilter?: boolean;
}
